import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri, filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getVideosInApp = createAsyncThunk(
  "videosInApp/getVideosInApp",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query, filter } = args;
      const filterParams = filterRequest(filter);
      const { data } = await axios.get(
        `${apiUri}/reels?page=${page}&size=${size}&query=${query}&adminOnly=true${filterParams}`,
        {
          headers: {
            'Content-Type': 'application/json',
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createVideoInApp = createAsyncThunk(
  "videosInApp/createVideoInApp",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.post(
        `${apiUri}/reels`,
        args,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateVideoInApp = createAsyncThunk(
  "videosInApp/updateVideoInApp",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.put(
        `${apiUri}/reels/${args.id}/status`,
        args.values,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteVideoInApp = createAsyncThunk(
  "videosInApp/deleteVideoInApp",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.delete(
        `${apiUri}/reels/${args.id}`,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const videosInAppSlice = createSlice({
  name: "videosInApp",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getVideosInApp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getVideosInApp.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data;
        state.itemsCount = payload.data?.itemsCount;
        state.pages = payload.data?.pages;
        state.error = null;
      })
      .addCase(getVideosInApp.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message
      })

      .addCase(createVideoInApp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createVideoInApp.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createVideoInApp.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateVideoInApp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateVideoInApp.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        if (indexAt !== -1) {
          state.data[indexAt] = payload.data;
        }
        state.error = null;
      })
      .addCase(updateVideoInApp.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteVideoInApp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteVideoInApp.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteVideoInApp.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default videosInAppSlice.reducer;
